import {ReportEnumBean} from 'common/api/api'
import {FC} from 'react'

import {DictionarySelector, DictionarySelectorProps, enumToLabelValue} from './DictionarySelector'

import SiteTypeEnum = ReportEnumBean.SiteTypeEnum

export const SiteTypeSelector: FC<DictionarySelectorProps> = (props) => (
    <DictionarySelector {...props} cacheKey="siteType" loader={() => enumToLabelValue(SiteTypeEnum)}/>
)
